import { IS_CLIENT, IS_PRODUCTION } from '@repo/common-utils';

import { SendEventParams } from '../types';

export class GoogleAnalyticsService {
  private preservedEvents: SendEventParams[] = [];
  private retryCount: number = 0;
  private retryTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    this.init();
  }

  private init() {
    if (!IS_CLIENT) return;
    this.sendInitEvent();
  }

  sendEvent(params: SendEventParams) {
    const isInitGa = window.dataLayer?.some((entry: any) => entry[0] === 'config' && typeof entry[1] === 'string' && entry[1].startsWith('G-'));

    if (typeof window.gtag !== 'function' || !isInitGa) {
      this.preservedEvents.push(params);
      return;
    }

    const eventNameParams = [params?.category, params?.object, params?.detail, params?.action];
    const event = eventNameParams
      .filter((value) => !!value)
      .join('_')
      .replace(/[-.]/gi, '_');

    window.gtag('event', event, {
      debug_mode: !IS_PRODUCTION,
      value: params?.attributes?.amount,
      currency: params?.attributes?.amount ? 'KRW' : undefined,
      ...params?.attributes
    });
  }

  private sendInitEvent() {
    const isInitGa = window.dataLayer?.some((entry: any) => entry[0] === 'config' && typeof entry[1] === 'string' && entry[1].startsWith('G-'));

    if (typeof window.gtag === 'function' && isInitGa) {
      this.preservedEvents.forEach((event) => this.sendEvent(event));
      this.preservedEvents = [];
      return;
    } else if (this.retryCount < 10) {
      if (this.retryTimeout) clearTimeout(this.retryTimeout);
      this.retryTimeout = setTimeout(() => {
        this.retryCount++;
        this.sendInitEvent();
      }, 500);
    }
  }
}
